import { Events } from "./modules/events.js";
import { Utils } from "./modules/utils.js";
import { Audio } from "./modules/audio.js";
import { PerformanceMonitor } from "./modules/performance.js";
import { ConnectionQuality } from "./modules/connection.js";
import { WorkflowProfiler } from "./modules/profiler.js";
import { Workflow } from "./modules/workflow.js";
import { Live } from "./modules/live.js";
import { Layout } from "./modules/layout.js";
import { Menu } from "./modules/menu.js";
import { Modal } from "./modules/modal.js";
import { Debug } from "./modules/debug.js";
import { DebugPanel } from "./modules/debugpanel.js";
import { Overlay } from "./modules/overlay.js";
import { Theme } from "./modules/theme.js";
import { Signature } from "./modules/signature.js";
import * as App from "./modules/app.js";
import * as MagazynQR from "./modules/magazyn-qr.js";
import * as Helpers from "./modules/helpers.js";

// Lazy loading QR (opcjonalne)
async function loadMagazynQR() {
    return await import("./modules/magazyn-qr.js");
}

export const FixSystem = {
    Events,
    Utils,
    Audio,
    PerformanceMonitor,
    ConnectionQuality,
    WorkflowProfiler,
    Workflow,
    Live,
    Layout,
    Menu,
    Modal,
    Debug,
    DebugPanel,
    Overlay,
    Theme,
    Signature,
    App,
    MagazynQR,
    Helpers,
    loadMagazynQR
};

document.addEventListener("DOMContentLoaded", () => {
    Workflow.init();
    PerformanceMonitor.startEventsCounter();
    Theme.init();
});

Audio.register("sla-expired", "/sounds/alert.mp3");

// Test QR (opcjonalny)
FixSystem.loadMagazynQR().then(({ generateQRCode }) => {
    generateQRCode("qr", "ABC123");
});

window.FixSystemCallLater = (dotnetRef, methodName, delay) => {
    setTimeout(() => {
        dotnetRef.invokeMethodAsync(methodName);
    }, delay);
};

// Globalne funkcje pomocnicze dla Blazor JS Interop
window.isMobile = () => {
    return window.innerWidth <= 768 || 
           /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

window.enableDrag = (elementId) => {
    const el = document.getElementById(elementId);
    if (!el) return;
    
    let isDragging = false;
    let startX, startY, initialX, initialY;
    
    el.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        initialX = el.offsetLeft;
        initialY = el.offsetTop;
        el.style.cursor = 'grabbing';
    });
    
    document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        el.style.left = (initialX + dx) + 'px';
        el.style.top = (initialY + dy) + 'px';
    });
    
    document.addEventListener('mouseup', () => {
        isDragging = false;
        el.style.cursor = 'grab';
    });
};

window.setTheme = (file) => {
    FixSystem.Theme.setTheme(file);
};

// W index.js
window.FixSystemCallLater = (dotnetRef, methodName, delay) => {
    const call = () => {
        // Sprawdź czy FixSystem i konkretny moduł już istnieją
        if (window.FixSystem) {
            dotnetRef.invokeMethodAsync(methodName);
        } else {
            // Jeśli jeszcze nie ma, spróbuj ponownie za chwilę
            setTimeout(call, 50);
        }
    };
    setTimeout(call, delay);
};

// Globalne funkcje pomocnicze dla Blazor (interfejs mostkowy)
window.initSignature = (canvasId) => {
    FixSystem.Signature.init(canvasId);
};

window.clearSignature = () => {
    FixSystem.Signature.clear();
};

window.getSignatureImage = () => {
    return FixSystem.Signature.getDataUrl();
};

window.playServiceAlertOnce = (zlecenieId) => {
    try {
        if (window.FixSystem && window.FixSystem.Audio && typeof window.FixSystem.Audio.playOnce === "function") {
            window.FixSystem.Audio.playOnce("sla-expired", zlecenieId);
        }
    } catch (e) {
        console.warn("playServiceAlertOnce skipped:", e);
    }
};

window.FixSystem = FixSystem;

// Wczytywanie pliku z <input type="file"> przez base64 → Blazor DotNet callback.
// Używane przez ZasilaczWpisDialog (InputFile nie działa w portalach Radzena na mobile).
window.fixsystemBindFileInput = function(inputId, dotnetRef) {
    // Krótkie opóźnienie — dialog może jeszcze renderować DOM
    setTimeout(function() {
        const input = document.getElementById(inputId);
        if (!input) {
            console.warn('[FixSystem] bindFileInput: brak elementu', inputId);
            return;
        }
        if (input._fsListener) {
            input.removeEventListener('change', input._fsListener);
        }
        input._fsListener = function() {
            const file = this.files && this.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function(e) {
                const base64 = e.target.result.split(',')[1];
                dotnetRef.invokeMethodAsync('OnFileSelectedBase64', base64, file.type, file.name, file.size)
                    .catch(function(err) { console.error('[FixSystem] OnFileSelectedBase64 error:', err); });
            };
            reader.onerror = function() {
                console.error('[FixSystem] FileReader error');
            };
            reader.readAsDataURL(file);
            // reset — żeby można wybrać ten sam plik ponownie
            this.value = '';
        };
        input.addEventListener('change', input._fsListener);
    }, 80);
};

// Sticky footer: mierzy dostępną wysokość i ustawia ją bezpośrednio na .nowe-scroll-area
window.initStickyFooter = function() {
    function apply() {
        const scrollArea = document.querySelector('.nowe-scroll-area');
        const footerBar  = document.querySelector('.nowe-footer-bar');
        const page       = document.querySelector('.nowe-przyjecia-page');
        if (!scrollArea || !footerBar || !page) return;

        const ca = page.parentElement; // = .content-area
        if (!ca) return;

        const cs   = getComputedStyle(ca);
        const caH  = ca.clientHeight
                   - parseFloat(cs.paddingTop  || '0')
                   - parseFloat(cs.paddingBottom || '0');
        const h = caH - footerBar.offsetHeight;

        if (h > 50) {
            scrollArea.style.height    = h + 'px';
            scrollArea.style.overflowY = 'auto';
            scrollArea.style.minHeight = '0';
        }
    }

    window._stickyFooterCb = apply;
    window.addEventListener('resize', apply);
    requestAnimationFrame(apply); // poczekaj na layout przeglądarki
};

window.destroyStickyFooter = function() {
    const sa = document.querySelector('.nowe-scroll-area');
    if (sa) {
        sa.style.height    = '';
        sa.style.overflowY = '';
        sa.style.minHeight = '';
    }
    if (window._stickyFooterCb) {
        window.removeEventListener('resize', window._stickyFooterCb);
        window._stickyFooterCb = null;
    }
};